import { render, staticRenderFns } from "./SampleTypeForm.vue?vue&type=template&id=fa0184e0"
import script from "./SampleTypeForm.vue?vue&type=script&lang=js"
export * from "./SampleTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports